<template>
  <v-dialog
    v-model="dialog"
    retain-focus
    max-width="450"
    content-class="rtls-dialog"
    @keydown.esc="close"
    @click:outside="close"
  >
    <!-- This is the actual trash icon visible before clicking the modal -->
    <template #activator="{ props: activatorProps }">
      <v-tooltip location="bottom">
        <template #activator="{ props: tooltipActivatorProps }">
          <v-btn
            v-bind="{ ...activatorProps, ...tooltipActivatorProps }"
            density="comfortable"
            variant="text"
            icon="$trash"
            :disabled="disabled"
            :loading="loading"
          />
        </template>
        <span>{{ $t('actions.delete') }}</span>
      </v-tooltip>
    </template>

    <BaseDialogCard ref="dialog" :title="tkey('title')" :border="true" @close="close">
      <v-card-text class="text-h6">
        <p class="pb-2">{{ questionMessage }}</p>
        <strong>{{ tkey('warning') }}</strong>
      </v-card-text>

      <template #footer>
        <v-card-actions>
          <v-btn primary @click="close">
            {{ $t('actions.cancel') }}
          </v-btn>
          <v-btn secondary variant="flat" class="outlined-btn" @click="_deleteWorkpackage">
            {{ actionMessage }}
          </v-btn>
        </v-card-actions>
      </template>
    </BaseDialogCard>
  </v-dialog>
</template>

<script>
import { mapActions } from 'pinia';
import entities from '@enums/entities';
import { useWorkpackagesStore } from '@/stores/workpackages';
import { useInternationalization } from '@/composables/use-internationalization';
import { useFeature } from '@/composables/use-feature';

export default {
  props: {
    workpackage: {
      required: true,
      type: Object,
    },
    entity: {
      type: String,
      required: false,
      default: '',
    },
  },

  setup() {
    const { tkey } = useInternationalization('workpackages.options.delete');

    const { betaTemplateDeleteEnabled } = useFeature();
    return { tkey, betaTemplateDeleteEnabled };
  },

  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  computed: {
    workpackageName() {
      return this.workpackage.name;
    },
    disabled() {
      return false;
      // TODO vuetify
      // return !this.hasPermission(this.userPermissions.canDeleteWorkpackage);
    },
    isTemplate() {
      return this.entity === entities.template;
    },
    questionMessage() {
      if (this.isTemplate) {
        return this.$t('templatesPage.options.delete.question', {
          templateName: this.workpackageName,
        });
      }

      return this.tkey('question', { workpackageName: this.workpackageName });
    },
    actionMessage() {
      if (this.isTemplate) {
        return this.$t('templatesPage.options.delete.action');
      }

      return this.tkey('action');
    },
  },
  methods: {
    ...mapActions(useWorkpackagesStore, [
      'setWorkpackageSetupExpanded',
      'setSelectedWorkpackage',
      'setScenarioPanelExpanded',
      'deleteWorkpackage',
      'deleteTemplate',
    ]),
    async _deleteWorkpackage() {
      this.loading = true;
      try {
        this.close();

        if (!this.betaTemplateDeleteEnabled && this.isTemplate) return;

        if (this.isTemplate) {
          await this.deleteTemplate(this.workpackage);
          return;
        }

        await this.deleteWorkpackage(this.workpackage);
        this.setWorkpackageSetupExpanded(false);
        this.setSelectedWorkpackage(null);
        this.setScenarioPanelExpanded(false);
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
